import type { BaseDocumentDto } from './models';
import { RestService } from '@abp/ng.core';
import type { ListResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DocumentLookupService {
  apiName = 'Default';
  

  getDocumentLookup = () =>
    this.restService.request<any, ListResultDto<BaseDocumentDto>>({
      method: 'GET',
      url: '/api/app/document-lookup/document-lookup',
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
